import request from '@/utils/request'

let Government_parkApi = {

  /*政府园区列表*/
  list(data) {
    return request._post('/shop/plus.government_park.Index/index', data);
},
/*添加政府园区*/
add(data) {
    return request._post('/shop/plus.government_park.Index/add', data);
},
/*修改政府园区*/
edit(data) {
    return request._post('/shop/plus.government_park.Index/edit', data);
},
/*删除政府园区*/
del(data) {
    return request._post('/shop/plus.government_park.Index/del', data);
},
/*政府园区详情*/
detail(data) {
  return request._post('/shop/plus.government_park.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.government_park.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.government_park.Setting/getSetting', data, errorback);
    },
}
export default Government_parkApi;



// WEBPACK FOOTER //
// ./src/api/government_park.js